import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { InsurancePolicy } from '@/types/insurance';

type UpdateInsurancePolicyData = Partial<InsurancePolicy> & { id: string };

export function useUpdateInsurancePolicy() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, ...updates }: UpdateInsurancePolicyData) => {
      const { data, error } = await supabase
        .from('insurance_policies')
        .update(updates)
        .eq('id', id)
        .select()
        .single();
      if (error) throw error;
      return data as InsurancePolicy;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['insurance-policies'] });
    },
  });
}
